import {MultiUnitValue} from "./WarehouseReceipts";

export interface WarehouseEntity {
    total_items: number;
    total_pieces: number;
    total_weight: MultiUnitValue;
    total_volume: MultiUnitValue;
    total_volume_weight: MultiUnitValue;
}